import { useEffect, useState } from "react";

const KEY = "learnai-text-size";
export const TEXT_SIZES = [["small", "Small"], ["default", "Default"], ["large", "Large"]];

const apply = (v) => { document.documentElement.dataset.textSize = v; };

export function useTextSize() {
  const [size, setSize] = useState(() => localStorage.getItem(KEY) || "default");
  useEffect(() => {
    apply(size);
    localStorage.setItem(KEY, size);
    window.dispatchEvent(new CustomEvent("text-size-changed", { detail: size }));
  }, [size]);
  useEffect(() => {
    const on = (e) => setSize(e.detail);
    window.addEventListener("text-size-changed", on);
    return () => window.removeEventListener("text-size-changed", on);
  }, []);
  return [size, setSize];
}
